import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '/api',
  timeout: 12000
})

client.interceptors.request.use(config => {
  const token = localStorage.getItem('beep_art_admin_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

client.interceptors.response.use(response => response.data.data, error => Promise.reject(error.response?.data || error))

export default client
